import * as types from "../constants/actiontypes/sidebar";

export function toggleSidebar() {
  return {
    type: types.SIDEBAR_VISIBILITY_TOGGLE
  };
}
